import { Component, computed, input, output } from '@angular/core';

import { SvgIconsComponent } from '../svg-icons/svg-icons.component';
import { ClickableTextDirective } from '../../commonDirectives/clickableText/clickable-text.directive';
import { AlertItem } from './alerts-marquee.service';

export type AlertEntity = 'load' | 'dispatch' | 'trailer' | 'truck' | 'driver';

const ENTITY_BY_ACTION: Record<string, AlertEntity> = {
  'view-load': 'load',
  'view-dispatch': 'dispatch',
  'view-trailer': 'trailer',
  'view-truck': 'truck',
  'view-driver': 'driver',
};

@Component({
  selector: 'app-alerts-marquee-item',
  standalone: true,
  imports: [SvgIconsComponent, ClickableTextDirective],
  templateUrl: './alerts-marquee-item.component.html',
  styleUrl: './alerts-marquee-item.component.css',
})
export class AlertsMarqueeItemComponent {
  alert = input.required<AlertItem>();
  decorative = input<boolean>(false);
  openEntity = output<{ entity: AlertEntity; id: number }>();

  // on_click is "view-load" (target = object_id) or "view-load:<id>" (stops point at their load/dispatch)
  resolveTarget(link: AlertItem['object_links'][number]): { entity: AlertEntity; id: number } | null {
    const [action, targetId] = String(link?.on_click ?? '').split(':');
    const entity = ENTITY_BY_ACTION[action];
    const id = Number(targetId || link?.object_id);
    if (!entity || !id) return null;
    return { entity, id };
  }

  readonly icon = computed(() => {
    const a = this.alert();
    switch (a.code_group) {
      case 'LOAD_REEFER':
      case 'TEMPERATURE':
        return 'snow';
      case 'HOS':
      case 'DETENTION':
      case 'IDLE':
        return 'history';
      case 'GEOFENCE':
        return 'location';
      default:
        return a.priority === 'HIGH' ? 'warning' : 'info';
    }
  });

  readonly color = computed(() => {
    const p = this.alert().priority;
    if (p === 'HIGH') return 'var(--red-solid)';
    if (p === 'MEDIUM') return 'var(--amber-solid)';
    return 'var(--blue-solid)';
  });
}
